import { useEffect, useImperativeHandle, useState } from "react";
import Spacer from "../../../../components/layout/Spacer";
import Slide from "../../../../components/layout/Slide";
import { PilotAssignmentCommands } from "../../services/DispatcherActions";
import Switch from "../../../../components/layout/switch";
import { Card } from "../../../../components/layout/card/Card";
import { useHasEditableChanged } from '../hooks/usePilotAssignmentStore';

export const ConvertToPilotInclCard = (
    {
        ref,
        onExaminerOnlyChanged,
        onPilotAssignmentChanged,
        assignmentService
    }) => {

    useImperativeHandle(ref, () => ({
        onPilotageChanged() {
            initialize();
        }
    }));

    const [show, setShow] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [isEditable, setIsEditable] = useState(false);

    const hasEditableChanged = useHasEditableChanged();

    useEffect(() => {
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(!hasEditableChanged) return;
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasEditableChanged]);
    // husk å disable hvis losoppdraget er completed!!

    return (
        <Slide show={show}>
            <Spacer height={30} />
            <Card
                title="Var du b&aring;de sensor og los på oppdraget?"
                backgroundColor="var(--card-question-bg)">
                <p>
                    Dersom du ogs&aring; var ansvarlig los (farledsbevisinnehaver forlot brua),
                    gj&oslash;res oppdraget om til et losoppdrag slik at losingstimene kan faktureres.
                </p>
                <Switch
                    onLabel="Ja"
                    offLabel="Nei"
                    onChange={onChange}
                    checked={isChecked}
                    disabled={!isEditable}
                />
            </Card>
        </Slide>
    )

    function initialize() {
        const pilotAssignment = assignmentService.assignment;
        const hasCommand = assignmentService.hasCommandType(PilotAssignmentCommands.ConvertToPilotageIncl);

        setShow(
            pilotAssignment.isExaminer &&
            pilotAssignment.pilotage.pilotagePilotsInformation.length === 1 &&
            pilotAssignment.pilotage.canConvertToPilotIncl
        );
        setIsEditable(assignmentService.isEditable);
        setIsChecked(hasCommand);
    }

    function onChange(e) {
        setIsChecked(e.value);
        onUpdateAsync(e.value);
    }

    async function onUpdateAsync(canConvertToPilotIncl) {
        await assignmentService.onConvertToPilotageInclAsync(canConvertToPilotIncl);
        onPilotAssignmentChanged();
        onExaminerOnlyChanged();
    }
}
